module.exports = __webpack_public_path__ + "img/macau.e40dd59c.svg";